<div class="page" [ngClass]="{ 'is-widget': isWidget$ | async }">
  <div class="container container-lg no-container-widget">
    <app-breadcrumb></app-breadcrumb>

    <div class="wrapper-page wrapper-page--column" *ngIf="!noDetail">
      <!-- header -->
      <div class="page-header order-2 order-lg-1">
        <app-cruise-detail-header
          [passengers]="occupancy.guests"
          [cruise$]="cruise$"
          [bookingUrl]="bookingUrl"
        ></app-cruise-detail-header>
      </div>

      <!-- gallery -->
      <div class="page-gallery order-1 order-lg-2">
        <app-cruise-detail-gallery
          [cruise$]="cruise$"
        ></app-cruise-detail-gallery>
      </div>

      <!-- menu delle tabs in alto -->
      <div class="d-none d-md-block detail-tabs__container order-3">
        <app-cruise-detail-content-tabs
          [cruise$]="cruise$"
          [shipService$]="shipService$"
        >
        </app-cruise-detail-content-tabs>
      </div>

      <!-- Corpo principale della pagina, suddiviso in 3 tabs -->
      <div class="detail-container wrapper-page order-4 mt-4">
        <div
          class="detail-container__tabs wrapper-page__content order-2 order-lg-1"
        >
          <div class="detail-content__container" style="max-width: 100%">
            <!-- tab itinerario -->
            <div class="cruise-tab__map">
              <app-cruise-detail-content-itinerary [cruise$]="cruise$">
              </app-cruise-detail-content-itinerary>
            </div>
            <!-- tab cabine -->
            <div
              class="cruise-tab__cabins mt-4 mb-5"
              #priceGrid
              *ngIf="brand?.detailPageConfig.showPriceGrid"
            >
              <detail-price-grid
                [shipService$]="shipService$"
                [cruiseDetails]="cruise$ | async"
              >
              </detail-price-grid>

              <div
                class="detail-recap__row detail-content__cta"
                [ngClass]="{ 'is-widget': isWidget$ | async }"
                *ngIf="!isLanding && selectedCabinOnPriceGrid"
              >
                <!-- disabilito la cta prosegui solo se la griglia solutions/prezzi è visualizzata ma non è stata ancora selezionata
                nessuna cabina (in tutti gli altri casi invece, la cta è abilitata) -->
                <a
                  class="detail-recap__cta__button btn btn--brand-color-03"
                  dynamicNavigation
                  [ngClass]="{
                    disabled:
                      (brand?.detailPageConfig.showPriceGrid &&
                        !(isWidget$ | async)) ||
                      loadingPriceGridStatus
                  }"
                  [href]="bookingUrl"
                >
                  <span
                    *ngIf="
                      loadingPriceGridStatus &&
                      brand?.detailPageConfig.showPriceGrid
                    "
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span *ngIf="!loadingPriceGridStatus">Prosegui</span>
                  <span class="ms-1 icon-arrow-right"></span>
                </a>
              </div>
            </div>
            <!-- tab escursioni -->
            <div
              class="cruise-tab__excursions"
              *ngIf="(cruise$ | async)?.selectedSolution?.excursions"
            >
              <app-cruise-detail-content-excursions
                [cruise$]="cruise$"
              ></app-cruise-detail-content-excursions>
            </div>
            <!-- ponti e cabine -->
            <div class="cruise-tab__ship">
              <app-cruise-detail-content-ship
                [cruise$]="cruise$"
                [shipService$]="shipService$"
                [bookingUrl]="bookingUrl"
              >
              </app-cruise-detail-content-ship>
            </div>
          </div>
        </div>
        <!-- Scontrino laterale -->
        <div
          class="detail-container__aside wrapper-page__aside order-1 order-lg-2"
        >
          <div
            class="detail-recap__container"
            [ngClass]="{ 'detail-recap__container--fixed': fixedRecap }"
          >
            <app-cruise-detail-content-aside
              [cruise$]="cruise$"
              [isLanding]="isLanding"
            ></app-cruise-detail-content-aside>
            <div
              class="detail-container__aside wrapper-page__aside order-1 order-lg-2"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- In caso di errore -->
    <div class="wrapper-page wrapper-page--column" *ngIf="noDetail">
      <div class="c-zero-results">
        <div class="c-zero-results__message">
          <h3>Il prodotto da te cercato non è più disponibile o è scaduto.</h3>
          <p>
            Clicca
            <a href="javascript:void(0)" (click)="goToHomeRoute()">qui</a> per
            tornare all'homepage
          </p>
        </div>
        <div class="c-zero-results__image">
          <picture>
            <img
              src="./assets/images/no-results.svg"
              height="auto"
              width="auto"
              alt="No Results"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</div>
